import React from "react";
import { Row, Col, Button, Container, Card } from "react-bootstrap";
import { FaChevronLeft, FaTrash } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import { Sun, Moon } from "lucide-react";
import i18n from "../../../i18n";
import { useTheme } from "../../../hooks/useTheme";

const HEADER_HEIGHT = "5vh";

const ThemeToggleButton = () => {
  const { theme, toggleTheme } = useTheme();
  const label = theme === "dark" ? i18n.t("components.Sidebar.lightMode") : i18n.t("components.Sidebar.darkMode");
  return (
    <Col xs="auto" className="d-flex justify-content-center align-items-center">
      <Button
        variant="transparent"
        onClick={toggleTheme}
        aria-label={label}
        title={label}
        style={{
          border: "none",
          backgroundColor: "transparent",
          color: "var(--text-secondary)",
          width: "10vw",
          height: HEADER_HEIGHT,
        }}
      >
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ fontSize: "1.5rem", height: "100%" }}
        >
          {theme === "dark" ? <Sun size={24} /> : <Moon size={24} />}
        </div>
      </Button>
    </Col>
  );
};

const ActionButton = ({ onClick, icon, show, style }) => {
  return (
    <Col xs="auto" className="d-flex justify-content-center align-items-center">
      <Button
        className="text-white d-flex justify-content-center align-items-center p-0"
        onClick={onClick}
        style={{
          backgroundColor: "#17296B",
          border: "none",
          width: "10vw",
          height: HEADER_HEIGHT,
          borderRadius: "5px",
          visibility: show ? "visible" : "hidden",
          ...style,
        }}
      >
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ fontSize: "1.5rem", height: "100%" }}
        >
          {icon}
        </div>
      </Button>
    </Col>
  );
};

const HeaderMobile = ({
  showArrow = true,
  showDelete = true,
  showEdit = false,
  onArrow,
  onDelete,
  onEdit,
  children,
  className = "",
}) => {
  return (
    <Container fluid className={`p-2 bg-transparent rounded ${className}`}>
      <Row className="align-items-center justify-content-center g-2">
        {showArrow && (
          <ActionButton
            onClick={onArrow}
            icon={<FaChevronLeft />}
            show={showArrow}
          />
        )}

        <Col className="text-center d-flex justify-content-center align-items-center">
          <Card
            className="d-flex justify-content-center align-items-center"
            style={{
              minWidth: "50vw",
              backgroundColor: "#17296B",
              height: HEADER_HEIGHT,
              fontWeight: "bold",
            }}
          >
            <span
              className="text-white"
              style={{
                fontSize: "1.6rem",
              }}
            >
              {children}
            </span>
          </Card>
        </Col>

        {showEdit && (
          <ActionButton
            onClick={onEdit}
            icon={<MdModeEdit />}
            show={showEdit}
          />
        )}

        {showDelete && (
          <ActionButton
            onClick={onDelete}
            icon={<FaTrash />}
            show={showDelete}
          />
        )}

        <ThemeToggleButton />
      </Row>
    </Container>
  );
};

export default HeaderMobile;
